import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import UtilDate from '../../../utils/UtilDate';
import UtilObject from '../../../utils/UtilObject';
import UtilNotify from '../../../utils/UtilNotify';
import MyModal from '../../../components/myModal/MyModal';
import NotificationActions from '../../../actions/NotificationActions';
import ActivityRightCardRow from '../../dashboard/activity/activityRightCardRow/ActivityRightCardRow';

const NotificationViewModal = forwardRef(({ onChange }, ref) => {
  const { t } = useTranslation();

  const refModal = useRef(null);

  const [notification, setNotification] = useState(UtilObject.EMPTY_OBJECT);

  useImperativeHandle(ref, () => ({
    viewNotification: (noti) => {
      setNotification(noti);
      refModal?.current?.open();
    },
  }));

  useEffect(() => {
    const setReaded = async () => {
      if (
        !UtilObject.isEmpty(notification) &&
        notification.notifRead === NotificationActions.STATUS.NOTREADED
      ) {
        const result = await NotificationActions.save(notification?.idNotif, {
          notifRead: NotificationActions.STATUS.READED,
        });
        if (result.success) {
          onChange && onChange(notification?.idNotif);
        } else {
          UtilNotify.notifyErrorServer(result.errMsg);
        }
      }
    };
    setReaded();
  }, [notification, onChange]);

  return (
    <MyModal ref={refModal} title={t('WORD_NOTIFICATION')} hideFooter>
      <ActivityRightCardRow
        title={t('WORD_CREATE_DATE')}
        data={UtilDate.formatDateTime(notification.notifDate)}
        noSpace
        bold
      />
      <ActivityRightCardRow
        title={t('WORD_MESSAGE')}
        data={notification.notifText}
        noSpace
        bold
      />
    </MyModal>
  );
});

export default NotificationViewModal;
